"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/** @jsx jsx */

var react_web_components_1 = require("@nimles/react-web-components");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = require("@emotion/react");

var ProductList_1 = require("./ProductList");

var Header_1 = require("./Header");

var Main_1 = require("./Main");

var ShoppingCartMenu_1 = require("./ShoppingCartMenu");

var UserMenu_1 = require("./UserMenu");

var Footer_1 = require("./Footer");

var Routes_1 = require("./Routes");

var ProductGroupsMenu_1 = require("./ProductGroupsMenu");

var Brand_1 = require("./Brand");

var HubSpotForm_1 = require("./HubSpotForm");

var NavButton_1 = require("./NavButton");

var PageList_1 = require("./PageList");

var PostList_1 = require("./PostList");

var Image = styled_1.default.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 100%;\n"], ["\n  max-width: 100%;\n"])));
var RichTextHtml = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));

exports.Element = function (_a) {
  var tenant = _a.tenant,
      element = _a.element,
      root = _a.root;
  var styles = !element.styles ? '' : Object.entries(element.styles).map(function (_a) {
    var key = _a[0],
        value = _a[1];
    return key + ": " + value + ";";
  }).join(' ');
  var customCss = react_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n    ", "\n  "], ["\n    ", "\n    ", "\n  "])), styles, element.css);
  var props = element.properties || {};

  switch (element.type) {
    case 'Column':
      return react_1.jsx(react_web_components_1.Column, __assign({
        flex: true,
        css: customCss
      }, props), element.children && element.children.map(function (element) {
        return react_1.jsx(exports.Element, {
          key: element.id,
          tenant: tenant,
          element: element,
          root: root
        });
      }));

    case 'Row':
      return react_1.jsx(react_web_components_1.Row, __assign({
        css: customCss
      }, props), element.children && element.children.map(function (element) {
        return react_1.jsx(exports.Element, {
          key: element.id,
          tenant: tenant,
          element: element,
          root: root
        });
      }));

    case 'Container':
      return react_1.jsx(react_web_components_1.Container, __assign({
        css: customCss
      }, props), element.children && element.children.map(function (element) {
        return react_1.jsx(exports.Element, {
          key: element.id,
          tenant: tenant,
          element: element,
          root: root
        });
      }));

    case 'Section':
      return react_1.jsx(react_web_components_1.Section, __assign({
        css: customCss
      }, props), element.children && element.children.map(function (element) {
        return react_1.jsx(exports.Element, {
          key: element.id,
          tenant: tenant,
          element: element,
          root: root
        });
      }));

    case 'Card':
      return react_1.jsx(react_web_components_1.Card, __assign({
        css: customCss
      }, props), element.children && element.children.map(function (element) {
        return react_1.jsx(exports.Element, {
          key: element.id,
          tenant: tenant,
          element: element,
          root: root
        });
      }));

    case 'Header':
      return element.children && element.children.length ? react_1.jsx(Header_1.Header, __assign({
        css: customCss
      }, props), element.children ? element.children.map(function (element) {
        return react_1.jsx(exports.Element, {
          key: element.id,
          tenant: tenant,
          element: element,
          root: root
        });
      }) : null) : react_1.jsx(Header_1.Header, __assign({
        css: customCss
      }, props, {
        layoutId: element.content
      }));

    case 'Footer':
      return react_1.jsx(Footer_1.Footer, __assign({
        css: customCss
      }, props), element.children ? element.children.map(function (element) {
        return react_1.jsx(exports.Element, {
          key: element.id,
          tenant: tenant,
          element: element,
          root: root
        });
      }) : null);

    case 'Main':
      return react_1.jsx(Main_1.Main, __assign({
        css: customCss
      }, props), element.children && element.children.map(function (element) {
        return react_1.jsx(exports.Element, {
          key: element.id,
          tenant: tenant,
          element: element,
          root: root
        });
      }));

    case 'Routes':
      return react_1.jsx(Routes_1.Routes, __assign({
        css: customCss
      }, props));

    case 'Text':
      return react_1.jsx("div", __assign({
        css: customCss
      }, props), element.content);

    case 'RichTextHtml':
    case 'Html':
      return react_1.jsx(RichTextHtml, {
        css: customCss,
        dangerouslySetInnerHTML: {
          __html: element.content
        }
      });

    case 'Image':
      return react_1.jsx(Image, __assign({
        css: customCss
      }, props, {
        src: "https://media.nimles.com/file/" + tenant.id + "/" + element.content + "?width=860"
      }));

    case 'NavButton':
      return react_1.jsx(NavButton_1.NavButton, __assign({
        css: customCss
      }, props), element.content);

    case 'ProductList':
      return react_1.jsx(ProductList_1.ProductList, __assign({
        css: customCss
      }, props));

    case 'ShoppingCartMenu':
      return react_1.jsx(ShoppingCartMenu_1.ShoppingCartMenu, __assign({
        css: customCss
      }, props));

    case 'ProductGroupsMenu':
      return react_1.jsx(ProductGroupsMenu_1.ProductGroupsMenu, __assign({
        css: customCss
      }, props));

    case 'UserMenu':
      return react_1.jsx(UserMenu_1.UserMenu, __assign({
        css: customCss
      }, props));

    case 'Brand':
      return react_1.jsx(Brand_1.Brand, __assign({
        css: customCss
      }, props));

    case 'Heading1':
      return react_1.jsx(react_web_components_1.Heading1, __assign({
        inheritColor: root === 'Footer' || root === 'Header',
        css: customCss
      }, props), element.content);

    case 'Heading2':
      return react_1.jsx(react_web_components_1.Heading2, __assign({
        inheritColor: root === 'Footer' || root === 'Header',
        css: customCss
      }, props), element.content);

    case 'Heading3':
      return react_1.jsx(react_web_components_1.Heading3, __assign({
        inheritColor: root === 'Footer' || root === 'Header',
        css: customCss
      }, props), element.content);

    case 'Heading4':
      return react_1.jsx(react_web_components_1.Heading4, __assign({
        inheritColor: root === 'Footer' || root === 'Header',
        css: customCss
      }, props), element.content);

    case 'Heading5':
      return react_1.jsx(react_web_components_1.Heading5, __assign({
        inheritColor: root === 'Footer' || root === 'Header',
        css: customCss
      }, props), element.content);

    case 'Heading6':
      return react_1.jsx(react_web_components_1.Heading6, __assign({
        inheritColor: root === 'Footer' || root === 'Header',
        css: customCss
      }, props), element.content);

    case 'HubSpotForm':
      return react_1.jsx(HubSpotForm_1.HubSpotForm, __assign({
        css: customCss
      }, props));

    case 'PageList':
      return react_1.jsx(PageList_1.PageList, __assign({
        css: customCss,
        style: root === 'Footer' || root === 'Header' ? 'menu' : 'list'
      }, props));

    case 'PostList':
      return react_1.jsx(PostList_1.PostList, __assign({
        css: customCss,
        style: root === 'Footer' || root === 'Header' ? 'menu' : 'list'
      }, props));

    default:
      return null;
  }
};

var templateObject_1, templateObject_2, templateObject_3;